import * as _4 from 'lodash4';
import { SchedulerModel } from '../../views/course_scheduler/models/scheduler_model';

export class SystemMessageController {
  private systemCustomTextMessage: string = '';
  private showSystemMessage: boolean = false;
  constructor(private ngSchedulerModel: SchedulerModel) {}

  $onInit() {
    this.systemCustomTextMessage = _4.get(this.ngSchedulerModel.read(), 'customtext.SCHEDULER_WARNING.text', '');
    this.showSystemMessage = !_4.isEmpty(this.systemCustomTextMessage);
  }
}

angular.module('capability-ng-scheduler').component('systemMessage', {
  controller: SystemMessageController,
  templateUrl: 'capability-ng-scheduler/src/components/system_message/system_message.html'
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/system_message/system_message.ts